// CompanyLocationSelect_PhaseTwo.jsx (updated, with original lines preserved in comments)

import React, { useEffect, useState, useMemo } from 'react';
import useQuery from 'lib/hooks/useQuery';
import TextField from '@material-ui/core/TextField';
import { getIn } from 'formik';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSelector, useDispatch } from 'react-redux';
import { actions as companyActions } from 'redux/companies';
import { actions as locationActions } from 'redux/locations';
import _ from 'lodash';
// import api from 'lib/api'; // (unused)
import { Link, useParams } from 'react-router-dom';
import utils, { decryptionInHex, getDecryptedRouteParams, getDecryptedUrl } from 'lib/utils';
import ShieldIcon from 'common/Shield/shield';
import YellowShieldIcon from 'assets/images/icons/Badge_yellow.svg';

export default function CompanyLocationSelect(props) {
  const {
    field,
    form: { touched, errors, values, setFieldValue },
    label,
    children,
    select,
    variant,
    initialDisplayText,
    entity_id,
    company_affiliate_enum,
    disabled,
    placeholder,
    setDealChargesParams,
    setPrepaidBalance,
    setIsNotSubscribedLoacation,
    setIsPrepaidPlanLocation,
    setPackagingParams,
    isEditBidPopup,
    setIsLUTLocation,
    setIsSezLocation,
    getStockDetails,
    getTransportationCharges,
    formik,
    setFromLocationId,
    setToLocationId,
    isBidPopup,
    isProcessingDeal,
    isProcessingDealBilling,
    showClear,
    cb, // (explicitly referenced later)
    ...rest
  } = props;

  const { ctIndentCompany } = useQuery();
  let { id, iscopy } = getDecryptedRouteParams(useParams());
  // id = decryptionInHex(id);
  // let loading = false; // ORIGINAL
  // let options = [];    // ORIGINAL
  const loc = getDecryptedUrl(window.location.href);

  // CHANGED: keep Autocomplete value and options in state
  const [value, setValue] = React.useState(null);
  const [options, setOptions] = useState([]);
  const loading = options.length === 0;

  const dispatch = useDispatch();
  const locations = useSelector((state) => state.locations);
  // ORIGINAL:
  // const locationData = ctIndentCompany || isProcessingDeal ? _.get(locations, `entities`) || {} : _.get(locations, `locations`) || {};
  const user = useSelector((state) => state.user);
  const acl = utils.getACL(user);

  // CHANGED: stable Autocomplete id instead of Date.now()
  const autocompleteId = `mui-autocomplete-${field?.name || 'company-location'}`;
  // ORIGINAL (caused remounts each render):
  // id={`mui-autocomplete-${Date.now()}`}

  // CHANGED: memoize which branch of locations to read
  const locationData = useMemo(() => {
    return ctIndentCompany || isProcessingDeal
      ? _.get(locations, 'entities') || {}
      : _.get(locations, 'locations') || {};
  }, [locations, ctIndentCompany, isProcessingDeal]);

  // ORIGINAL: Build options inline per render
  // if (entity_id) {
  //   _.each(locationData, (item, id) => {
  //     if (item.entity_id === entity_id || item.company_id === item.company_id) {
  //       options.push({
  //         label: item.address_text || item.location_code || '',
  //         value: {
  //           id: parseInt(id),
  //           ...item,
  //         },
  //       });
  //     }
  //   });
  // }
  // if (!options.length) {
  //   loading = true;
  // }

  // CHANGED: build options whenever locationData/entity_id change
  useEffect(() => {
    const next = [];
    _.each(locationData, (item, idKey) => {
      // NOTE: your original condition had `item.company_id === item.company_id` (always true).
      // Keeping original intent: filter by entity_id if provided.
      if (!entity_id || item.entity_id === entity_id /* || item.company_id === item.company_id */) {
        next.push({
          label: item.address_text || item.location_code || '',
          value: {
            id: parseInt(idKey, 10),
            ...item,
          },
        });
      }
    });
    setOptions(next);
  }, [locationData, entity_id]);

  useEffect(() => {
    if (loc.includes("commodity/requirements/") && values?.delivery_term_enum == 2) {
      if (field?.name == "address_id") {
        // setValue("") // ORIGINAL
        setValue(null); // CHANGED: Autocomplete expects null for "no value"
      }
    }
  }, [values?.delivery_term_enum, loc, field?.name]);

  useEffect(() => {
    // setValue(null); // ORIGINAL kept
    setValue(null);
    if (setIsNotSubscribedLoacation) {
      setIsNotSubscribedLoacation(false)
    }
  }, [entity_id, options.length, setIsNotSubscribedLoacation]);

  // ORIGINAL (narrow deps and sometimes missed fetches)
  // useEffect(() => {
  //   if (ctIndentCompany || isProcessingDeal) {
  //     if (entity_id) {
  //       const params = {
  //         filters: {},
  //         offset: 0,
  //         page_Size: 100,
  //         company_id: entity_id,
  //       };
  //       dispatch(locationActions.fetchCompanyAndAffiliateLocations(params));
  //     }
  //   }
  //   else if (isProcessingDealBilling){
  //     if (entity_id) {
  //       const params = {
  //         entity_id: entity_id,
  //         person_company_affiliate_enum: 2,
  //         person_id: user.person_id
  //       }
  //       dispatch(locationActions.fetchBusinessAndAffiliateLocationsAgainstEntityId(params));
  //   }}
  //   else {
  //     if (values?.person_company_affiliate_enum && entity_id) {
  //       const params = {
  //         entity_id: entity_id,
  //         person_company_affiliate_enum: values?.person_company_affiliate_enum,
  //         person_id: user.person_id
  //       }
  //       dispatch(locationActions.fetchBusinessAndAffiliateLocationsAgainstEntityId(params));
  //     }
  //   }
  // }, [entity_id]);

  // CHANGED: fetch effect with full relevant deps
  useEffect(() => {
    if (ctIndentCompany || isProcessingDeal) {
      if (entity_id) {
        const params = {
          filters: {},
          offset: 0,
          page_Size: 100,
          company_id: entity_id,
        };
        dispatch(locationActions.fetchCompanyAndAffiliateLocations(params));
      }
    } else if (isProcessingDealBilling) {
      if (entity_id) {
        const params = {
          entity_id: entity_id,
          person_company_affiliate_enum: 2,
          person_id: user.person_id,
        };
        dispatch(locationActions.fetchBusinessAndAffiliateLocationsAgainstEntityId(params));
      }
    } else {
      if (values?.person_company_affiliate_enum && entity_id) {
        const params = {
          entity_id: entity_id,
          person_company_affiliate_enum: values?.person_company_affiliate_enum,
          person_id: user.person_id,
        };
        dispatch(locationActions.fetchBusinessAndAffiliateLocationsAgainstEntityId(params));
      }
    }
  }, [
    dispatch,
    entity_id,
    ctIndentCompany,
    isProcessingDeal,
    isProcessingDealBilling,
    values?.person_company_affiliate_enum,
    user.person_id,
  ]);

  // useEffect(() => {
  //   getStockDetails && formik && getStockDetails(formik)
  //   getTransportationCharges && formik && getTransportationCharges(formik)
  // }, [loading, values, getStockDetails, getTransportationCharges, formik]);

  const debouncedGetStockDetails = useMemo(
    () => _.debounce((formikBag) => {
      getStockDetails && formikBag && getStockDetails(formikBag);
    }, 500),
    [getStockDetails]
  );

  const debouncedGetTransportationCharges = useMemo(
    () => _.debounce((formikBag) => {
      getTransportationCharges && formikBag && getTransportationCharges(formikBag);
    }, 500),
    [getTransportationCharges]
  );

  useEffect(() => {
    debouncedGetStockDetails(formik);
    debouncedGetTransportationCharges(formik);
  }, [ debouncedGetStockDetails, debouncedGetTransportationCharges]);

  // ORIGINAL (older initial-select effect commented by you)
  // useEffect(() => { ... }, [loading, values?.address_id, values?.buyer_bill_to_address_id, ...])

  // ORIGINAL (buyer_bill_to special-case + general initial set)
  // kept, but will also rely on options state; logic unchanged except uses `options`
  useEffect(() => {
    const initialAddressId = values?.[field.name] || 0;

    if (field.name === 'buyer_bill_to_address_id') {
      if (options.length > 0) {
        const match = options.find(
          (o) =>
            initialAddressId === o.value?.id ||
            initialAddressId === o.value?.company_address_id
        );

        if (initialAddressId && match) {
          setValue(match);
          setFieldValue(field.name, match.value?.company_address_id);

          setDealChargesParams?.({
            plan_id: match.value.subscription_plan_id,
            buyer_seller_id: match.value.entity_id,
            company_address_id: match.value.company_address_id,
            commodity_id: values.commodity_id,
            commodity_form_id: values.commodity_form_id,
          });

          setPrepaidBalance?.(match.value.prepaid_balance);
        }
      }
    } else {
      const match = options.find(
        (o) =>
          initialAddressId === o.value?.id ||
          initialAddressId === o.value?.company_address_id
      );

      if (initialAddressId && match) {
        setValue(match);

        setDealChargesParams?.({
          plan_id: match.value.subscription_plan_id,
          buyer_seller_id: match.value.entity_id,
          company_address_id: match.value.company_address_id,
          commodity_id: values.commodity_id,
          commodity_form_id: values.commodity_form_id,
        });

        setPrepaidBalance?.(match.value.prepaid_balance);
      }
    }
  }, [
    options.length,
    options, // CHANGED: ensure it reacts to options array changes
    values?.[field.name],
    values?.commodity_id,
    values?.commodity_form_id,
    field.name,
    setFieldValue,
    setDealChargesParams,
    setPrepaidBalance,
  ]);

  useEffect(() => {
    const initialSelected = options.filter((o) => values?.[field.name] === o.value?.id);
    if (initialSelected.length > 0) {
      let isLUTLocation = _.get(initialSelected[0], 'value.is_lut_location')
      let isSezLocation = _.get(initialSelected[0], 'value.is_sez_location')
      let addressId = _.get(initialSelected[0], 'value.id')
      setIsLUTLocation && setIsLUTLocation(isLUTLocation)
      setIsSezLocation && setIsSezLocation(isSezLocation)
      if (isLUTLocation || isSezLocation) {
        setFieldValue('bill_to_address_id', addressId);
        setValue(initialSelected[0]);
      }
      // props.cb(initialSelected[0])
    }
  }, [values?.address_id, options, setFieldValue, setIsLUTLocation, setIsSezLocation, field?.name, values]);

  const getSubscriptionValidation = (isSubscribed, subscriptionPlanId) => {
    if (setIsNotSubscribedLoacation && setIsPrepaidPlanLocation) {
      if (isSubscribed) {
        setIsNotSubscribedLoacation(false);
        setIsPrepaidPlanLocation(false);
        if (subscriptionPlanId === 1 || subscriptionPlanId === 2 || subscriptionPlanId === 3 || subscriptionPlanId === 9) {
          setIsPrepaidPlanLocation(true);
        }
      } else {
        if (acl.isCompany) {
          setIsNotSubscribedLoacation(true);
          setIsPrepaidPlanLocation(false);
        } else {
          setIsNotSubscribedLoacation(false);
          setIsPrepaidPlanLocation(false);
        }
      }
    }
  };

  useEffect(() => {
    // ORIGINAL:
    // if (options.length === 1 && field.name != 'bill_to_address_id') {
    //   setValue(options[0]);
    //   const addressId = _.get(options[0], 'value.company_address_id') || 0;
    //   setFieldValue(field.name, addressId);
    //   props.cb(options[0]);
    // } else if (options.length && field.name != 'bill_to_address_id') {
    //   let selectedAddress;
    //   let addressId = values[field.name];
    //   if (
    //     (loc.includes('create') ||
    //       loc.includes(`overview`) ||
    //       loc.includes(`details`) ||
    //       loc.includes(`bids`) ||
    //       loc.includes(`deals`) ||
    //       loc.includes(`balance-position`)) && !values[field.name]
    //   ) {
    //     selectedAddress = options.filter((item) => item?.value?.is_registered === true);
    //   }
    //   if (selectedAddress?.length) {
    //     addressId = addressId || _.get(selectedAddress?.[0], 'value.company_address_id') || 0;
    //     setFieldValue(field.name, addressId);
    //     let isLUTLocation = _.get(selectedAddress?.[0], 'value.is_lut_location');
    //     let isSezLocation = _.get(selectedAddress?.[0], 'value.is_sez_location');
    //     setIsLUTLocation && setIsLUTLocation(isLUTLocation);
    //     setIsSezLocation && setIsSezLocation(isSezLocation);
    //     setValue(selectedAddress?.[0]);
    //     props.cb(selectedAddress?.[0]);
    //   }
    // }

    // CHANGED: identical logic, but will run reliably because `options` is state that updates
    if (options.length === 1 && field.name != 'bill_to_address_id') {
      setValue(options[0]);
      const addressId = _.get(options[0], 'value.company_address_id') || 0;
      setFieldValue(field.name, addressId);
      props.cb && props.cb(options[0]);
    } else if (options.length && field.name != 'bill_to_address_id') {
      let selectedAddress;
      let addressId = values[field.name];
      if (
        (loc.includes('create') ||
          loc.includes(`overview`) ||
          loc.includes(`details`) ||
          loc.includes(`bids`) ||
          loc.includes(`deals`) ||
          loc.includes(`balance-position`)) && !values[field.name]
      ) {
        selectedAddress = options.filter((item) => item?.value?.is_registered === true);
      }
      if (selectedAddress?.length) {
        addressId = addressId || _.get(selectedAddress?.[0], 'value.company_address_id') || 0;
        setFieldValue(field.name, addressId);
        let isLUTLocation = _.get(selectedAddress?.[0], 'value.is_lut_location');
        let isSezLocation = _.get(selectedAddress?.[0], 'value.is_sez_location');
        setIsLUTLocation && setIsLUTLocation(isLUTLocation);
        setIsSezLocation && setIsSezLocation(isSezLocation);
        setValue(selectedAddress?.[0]);
        props.cb && props.cb(selectedAddress?.[0]);
      }
    }
  }, [options, entity_id, field.name, loc, props, setFieldValue, setIsLUTLocation, setIsSezLocation, values]);

  const hasError = !!(getIn(touched, field.name) && getIn(errors, field.name));
  const errText = hasError ? getIn(errors, field.name) : '';

  return (
    <div className={`mui-single-select bfc-ref-data-select-wrapper ${hasError ? 'has-error' : ''}`}>
      <Autocomplete
        id={autocompleteId}
        // ORIGINAL (unstable and caused remounts):
        // id={`mui-autocomplete-${Date.now()}`}
        // multiple
        size="small"
        disableClearable={!showClear}
        fullWidth
        loading={loading}
        disabled={disabled || loading}
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option;
          } else if (Array.isArray(option)) {
            return _.get(option, `[0].label`) || '';
          } else {
            return option.label || '';
          }
        }}
        onInputChange={(event, newInputValue, reason) => {
          // ORIGINAL:
          // if (newInputValue === '' && field.name == 'address_id' && loc.includes("commodity/requirements/") && showClear) {
          //   setFieldValue(field.name, null)
          //   setValue("")
          //   setTimeout(()=>{
          //     setFieldValue(field.name, null)
          //     setValue("")
          //   },1000)
          // }

          // CHANGED: use null instead of "" for clearing, and respect MUI reason
          if ((reason === 'clear' || newInputValue === '') && field.name === 'address_id' && loc.includes("commodity/requirements/") && showClear) {
            setFieldValue(field.name, null);
            setValue(null);
            setTimeout(() => {
              setFieldValue(field.name, null);
              setValue(null);
            }, 1000);
          }
        }}
        renderOption={(option) => {
          let messageColor = '';
          switch (option.value.subscription_plan_name || option.value.plan_name) {
            case 'Prepaid Pack':
            case 'Top Up':
              messageColor = '#1B62AB';
              break;
            case 'Business Pack':
              messageColor = '#1B62AB';
              break;
            case 'Bioenergy Pack':
              messageColor = '#1B62AB';
              break;
            case 'Enterprise Pack':
              messageColor = '#707070';
              break;
          }
          return (
            <table className="w-100">
              <tbody>
                <tr>
                  <td>{option.label}</td>
                  <td style={{ float: 'right' }}>
                    {(option.value.is_subscribed || values?.isCompanyAffSubscribed) ? (
                      <>
                        {option.value.subscription_plan_name === 'Prepaid Pack' || option.value.subscription_plan_name === 'Top Up' || option.value.plan_name === 'Prepaid Pack' ? (
                          // <p style={{ color: messageColor }}>
                          //   {option.value.prepaid_balance ? `₹: ${utils.formatQty(option.value.prepaid_balance)}` : `₹: 0`}</p>

                          (option?.value?.tick_color_enum == null || option?.value?.tick_color_enum == 0) ? (
                            <ShieldIcon
                              dontShowPopUp={true}
                              tickvalue={10}
                            />
                          ) : (option?.value?.tick_color_enum == 5) ? (
                            <ShieldIcon
                              dontShowPopUp={true}
                              tickvalue={option?.value?.tick_color_enum}
                            />
                          ) : option?.value?.is_supplier_contract_signed ? (
                            <ShieldIcon
                              dontShowPopUp={true}
                              tickvalue={
                                option?.value?.tick_color_enum == null
                                  ? 10
                                  : option?.value?.tick_color_enum
                              }
                            />
                          ) : (
                            <img src={YellowShieldIcon} alt="" style={{ height: '20px', width: '20px' }} />
                          )


                        ) : (
                          <div className='d-flex align-items-center'>
                            <p style={{ color: messageColor }}>{option.value.is_subscribed ? option.value.subscription_plan_name || option.value.plan_name : ''}</p>
                            {
                              (option?.value?.tick_color_enum == null || option?.value?.tick_color_enum == 0) ? (
                                <ShieldIcon
                                  style={{ width: '20px', height: '20px', marginLeft: 6, marginTop: 0 }}
                                  dontShowPopUp={true}
                                  tickvalue={10}
                                />
                              ) : (option?.value?.tick_color_enum == 5) ? (
                                <ShieldIcon
                                  style={{ width: '20px', height: '20px', marginLeft: 6, marginTop: 0 }}
                                  dontShowPopUp={true}
                                  tickvalue={option?.value?.tick_color_enum}
                                />
                              ) : option?.value?.is_supplier_contract_signed ? (
                                <ShieldIcon
                                  style={{ width: '20px', height: '20px', marginLeft: 6, marginTop: 0 }}
                                  dontShowPopUp={true}
                                  tickvalue={
                                    option?.value?.tick_color_enum == null
                                      ? 10
                                      : option?.value?.tick_color_enum
                                  }
                                />
                              ) : (
                                <img src={YellowShieldIcon} alt="" style={{ height: '20px', width: '20px' }} />
                              )
                            }

                          </div>
                        )}
                      </>
                    ) : !values?.isCompanyAffSubscribed && (
                      <Link to="/subscription-packages" target="_blank">
                        Subscribe
                      </Link>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          );
        }}
        options={options}
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
          if (props.cb) {
            props.cb(newValue);
          } else {
            // CHANGED: keep Formik in sync even if cb isn't provided
            const addr =
              newValue?.value?.company_address_id ??
              newValue?.value?.id ??
              null;
            setFieldValue(field.name, addr);
            if (newValue) {
              setDealChargesParams?.({
                plan_id: newValue.value.subscription_plan_id,
                buyer_seller_id: newValue.value.entity_id,
                company_address_id: newValue.value.company_address_id,
                commodity_id: values.commodity_id,
                commodity_form_id: values.commodity_form_id,
              });
              setPrepaidBalance?.(newValue.value.prepaid_balance);
            }
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            {...field}
            fullWidth
            variant={variant || 'outlined'}
            label={label}
            children={children}
            select={select}
            error={hasError}
            helperText={errText}
            style={{ backgroundColor: 'white' }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            placeholder={placeholder}
          // address_id - The value 'solap' is not valid.
          />
        )}
      />
    </div>
  );
}
